// extracted by mini-css-extract-plugin
export default {"Container":"styles_Container__dgUYI","paymentTypeSelected":"styles_paymentTypeSelected__i2ayd","ChoiceContainer":"styles_ChoiceContainer__i6MKd"};